import classNames from "classnames"
import {
  afterSetState,
  boatDisplayText,
  hasAny,
  inchesToFeet,
  isset,
} from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class BoatPicker extends React.Component {
  constructor(props) {
    super(props)
    this.setBoatId = this.setBoatId.bind(this)
    this.getBoatDataById = this.getBoatDataById.bind(this)
    this.getOptions = this.getOptions.bind(this)
    this.currentValue = this.currentValue.bind(this)
    this.showErrors = this.showErrors.bind(this)
    this.selectBoat = null
    this.setSelectBoatElementRef = (element) => {
      this.selectBoat = element
    }
  }

  componentDidMount() {
    if (!isset(this.props.state.boatId) && this.props.state.userBoats[0].id) {
      this.setBoatId(this.props.state.userBoats[0].id)
    }
  }

  setBoatId(boatId) {
    if (boatId === "custom") {
      this.props.setGlobalState({
        loa: null,
        draft: null,
        height: null,
        beam: null,
        boatId: null,
      })
      this.props.setGlobalState({ boatCreated: "now" })
      afterSetState(this.props.debounceRequestsAndSetStateRestrictions)
      this.props.setGlobalState({ draftMissing: false, heightMissing: false })
    } else {
      const boat = this.getBoatDataById(boatId)
      this.props.setGlobalState(boat)
      this.props.setGlobalState({ boatCreated: "previously" })
      afterSetState(this.props.debounceRequestsAndSetStateRestrictions)
    }
  }

  getBoatDataById(boatId) {
    const boat = _.find(this.props.state.userBoats, { id: Number(boatId) })

    if (boat) {
      return {
        boatId,
        boatDisplayText: boatDisplayText(
          boat.name,
          inchesToFeet(boat.length_overall),
          boat.make
        ),
        loa: inchesToFeet(boat.length_overall),
        beam: inchesToFeet(boat.beam),
        draft: boat.draw && inchesToFeet(boat.draw),
        height: boat.height && inchesToFeet(boat.height),
      }
    }

    if (isset(this.props.selectBoatPage)) {
      this.props.newBoat()
    }
  }

  getOptions() {
    const userBoats = this.props.state.userBoats
    const rows = userBoats.map((userBoat) => {
      const boatText = `${userBoat.name}, ${inchesToFeet(
        userBoat.length_overall
      )}' ${userBoat.make}`
      return (
        <option key={userBoat.id} value={userBoat.id} id={userBoat.id}>
          {boatText}
        </option>
      )
    })
    if (!isset(this.props.selectBoatPage)) {
      rows.push(
        <option key="custom" id="newBoat" value="custom">
          (new boat)
        </option>
      )
    }
    return rows
  }

  currentValue() {
    return this.props.state.boatCreated === "now" &&
      !isset(this.props.selectBoatPage)
      ? "custom"
      : this.props.state.boatId
  }

  showErrors() {
    if (this.props.state.boatCreated !== "now") {
      return (
        <div className="list-group">
          {this.props.errors.loa && (
            <p id="loaErrorText" className="control-label">
              {this.props.errors.loa}
            </p>
          )}
          {this.props.errors.beam && (
            <p id="beamErrorText" className="control-label">
              {this.props.errors.beam}
            </p>
          )}
          {this.props.errors.depth && (
            <p id="depthErrorText" className="control-label">
              {this.props.errors.depth}
            </p>
          )}
          {this.props.errors.height && (
            <p id="heightErrorText" className="control-label">
              {this.props.errors.height}
            </p>
          )}
        </div>
      )
    }
  }

  render() {
    return (
      <div
        id="boatPicker"
        className={classNames("form-group", {
          "has-error": hasAny(Object.keys(this.props.errors)),
        })}
      >
        <label htmlFor="boat">Boat</label>
        <select
          className="form-control"
          id="boat"
          value={this.currentValue()}
          onChange={(event) => this.setBoatId(event.target.value)}
          ref={this.setSelectBoatElementRef}
        >
          {this.getOptions()}
        </select>
        {this.showErrors()}
      </div>
    )
  }
}

BoatPicker.propTypes = {
  state: PropTypes.shape({
    boatId: PropTypes.number,
    userBoats: PropTypes.array.isRequired,
    boatCreated: PropTypes.string,
  }),
  setGlobalState: PropTypes.func.isRequired,
  debounceRequestsAndSetStateRestrictions: PropTypes.func.isRequired,
  selectBoatPage: PropTypes.bool,
  newBoat: PropTypes.func,
  errors: PropTypes.shape({
    loa: PropTypes.string,
    beam: PropTypes.string,
    depth: PropTypes.string,
    height: PropTypes.string,
  }),
}

export default BoatPicker
